export enum EGoodType {
  Medicament = 'Dược phẩm',
  MedicalSupplies = 'Vật tư y tế',
  Other = 'Khác'
}
